<section class="left">
  <div class="card left-body d-none d-md-block d-lg-block">
    <nav class="nav-content">
      <div class="brand-logo">
        <a href="#">
          <img src="./assets/image/sideLogo2.png" width="150px" alt="brand-logo">
        </a>
      </div>
      <div class="nav-menu">
        <ul class="nav-items">
          <li class="items dashboard">
            <div class="row">
              <div class="col-lg-1">
                <img src="./assets/image/icons/Dashboard.png" class="mr-2">
              </div>
              <div class="col-lg-3">
                <a routerLink="/home">Dashboard</a>
              </div>
            </div>
            <p></p>
          </li>
          <li class="items sell">
            <div class="row">
              <div class="col-lg-1">
                <img src="./assets/image/icons/Sell.png" class="mr-2">
              </div>
              <div class="col-lg-3">
                <a routerLink="/sell">Sell</a>
              </div>
            </div>
            <p></p>
          </li>
          <li class="items purchase">
            <div class="row">
              <div class="col-lg-1">
                <img src="./assets/image/icons/Purchase.png" class="mr-2">
              </div>
              <div class="col-lg-3">
                <a routerLink="/purchase">Purchase</a>
              </div>
            </div>
            <p></p>
          </li>
          <li class="items data_Service">
            <div class="row">
              <div class="col-lg-1">
                <img src="./assets/image/icons/Data_Service.png" class="mr-2">
              </div>
              <div class="col-lg-3">
                <a routerLink="/dataservice">Data Services</a>
              </div>
            </div>
            <p></p>
          </li>
          <li class="items logout">
            <div class="row">
              <div class="col-lg-1">
                <img src="./assets/image/icons/data_room.png" class="mr-2" width="22">
              </div>
              <div class="col-lg-3">
                <a routerLink='/login'>Virtual Data Room</a>
              </div>
            </div>
            <p></p>
          </li>
          <!-- <li class="items community">
                      <div class="row">
                          <div class="col-lg-1">
                           <img src="./assets/image/icons/Community.png" class="mr-2">
                          </div>
                          <div class="col-lg-3">
                            <a href="https://join.slack.com/t/datapitcher/shared_invite/enQtOTYwODk1NjQyNzA5LWYyMmU0YjA2NDM3OTQ0YWJmNGQ0NTQwZGUxNTZmYTZkNzAyMWZhYjVjMmJhODhmN2VmODYxNGYzMWE4NThkMDM" target="blank">Community</a>
                          </div>
                       </div>
                      <p></p>
                  </li> -->
          <!-- <li class="items support">
                      <div class="row">
                          <div class="col-lg-1">
                           <img src="./assets/image/icons/Support.png"  class="mr-2">
                          </div>
                          <div class="col-lg-3">
                            <a routerLink="/support">Support Center</a>
                          </div>
                       </div>
                      <p></p>
                  </li> -->
          <!--  <li class="items setting">
                      <div class="row">
                          <div class="col-lg-1">
                           <img src="./assets/image/icons/News_Feeds.png" class="mr-2">
                          </div>
                          <div class="col-lg-3">
                            <a href="https://www.youtube.com/playlist?list=PL0MAH4Rc-sLH9TiYeYB-5UtQ_anEZXqDZ" target="blank">News Feed</a>
                          </div>
                       </div>
                      <p></p>
                  </li> -->
          <!-- <li class="items education">
                       <div class="row">
                          <div class="col-lg-1">
                          <img src="./assets/image/icons/Education.png" class="mr-2">
                          </div>
                          <div class="col-lg-3">
                            <a routerLink="/education">Education</a>
                          </div>
                       </div>
                      <p></p>
                  </li>
                  <li class="items logout">
                       <div class="row">
                          <div class="col-lg-1">
                         <img src="./assets/image/icons/app_store2.png" class="mr-2">
                          </div>
                          <div class="col-lg-3">
                            <a routerLink='/login'>App Store</a>
                          </div>
                       </div>
                      <p></p>
                  </li> -->
        </ul>
      </div>
    </nav>
  </div>
  <!--  <div class="nav-mob d-md-none d-lg-none">
      <div class="nav-menu">
          <ul class="nav-mob-items">
              <li class="mob-items"><a href="#">PROFILE</a>
              </li>
              <li class="mob-items"><a href="#">MARKET PLACE</a>
              </li>
              <li class="mob-items"><a href="#">PURCHASES</a>
              </li>
              <li class="mob-items"><a href="#">COMMUNITY</a>
              </li>
              <li class="mob-items"><a href="#">NOTIFICATION</a>
              </li>
              <li class="mob-items"><a href="#">WALLET</a></li>
              <li class="mob-items"><a href="#">ORDER HISTORY</a>
              </li>
              <li class="mob-items"><a href="#">LOGOUT</a></li>
              <li class="mob-items"><a href="#"><img src="" alt=""></a></li>
          </ul>
      </div>
  </div> -->
</section>